import { render, staticRenderFns } from "./ChangeBiz.vue?vue&type=template&id=597dcee1&scoped=true&lang=pug&"
import script from "./ChangeBiz.vue?vue&type=script&lang=ts&"
export * from "./ChangeBiz.vue?vue&type=script&lang=ts&"
import style0 from "./ChangeBiz.vue?vue&type=style&index=0&id=597dcee1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "597dcee1",
  null
  
)

export default component.exports